import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Toaster } from "../../components/ui/sonner";

export const SiteLayout = () => (
  <div className="min-h-screen bg-bm-cream text-bm-ink font-body grain">
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
    <Toaster position="top-center" richColors />
  </div>
);
